import { render, staticRenderFns } from "./BrandedApps.vue?vue&type=template&id=8e22573e&"
import script from "./BrandedApps.vue?vue&type=script&lang=js&"
export * from "./BrandedApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports